import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { Button, Col, Spinner } from "react-bootstrap";
import { TextField } from "@mui/material";
import ApiAuth from "../../../core/api/api.auth";
import SwalMessage from "../_Components/SwalMessage";
import { KeyFill } from "react-bootstrap-icons";
import { isMobile } from "react-device-detect";
import { PatternFormat } from "react-number-format";

const ForgotPassword = () => {
  const [timeForSendCod, setTimeForSendCod] = useState(0); // timer for get agine cod
  // set timer
  useEffect(() => {
    let myInterval = setInterval(() => {
      if (timeForSendCod > 0) {
        setTimeForSendCod(timeForSendCod - 1);
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });

  const [isLoading, setIsLoading] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const {
    handleSubmit: handleSubmit2,
    control: control,
    formState: { errors: errors2 },
  } = useForm({ defaultValues: { id: 0 } });

  const onSubmit2 = async (data) => {
    setIsLoading(true);
    try {
      data.phoneNumber = data.phoneNumber.replaceAll(" ", "");
      const response = await ApiAuth.forgotPassword(data);
      if (response.succeeded == true) {
        SwalMessage({
          title: response.message,
          iSsuccess: response.succeeded,
          timer: 10000,
        });
        setShowMessage(true);
        setTimeForSendCod(60);
      } else {
        SwalMessage({
          title: response.message,
          iSsuccess: response.succeeded,
          timer: 10000,
        });
        setShowMessage(false);
        setTimeForSendCod(0);
      }
      // history.goBack();
    } catch (error) {
      setShowMessage(false);
      setTimeForSendCod(0);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="w-100 h-100 "
      style={{
        overflow: isMobile ? "scroll" : "hidden",
        backgroundColor: isMobile ? "#ffffff" : "#f1f6f9",
      }}
    >
      <form id="form2" onSubmit={handleSubmit2(onSubmit2)}>
        {isMobile ? (
          <div>
            <div className="text-center">
              {" "}
              <img
                style={{ height: "200px" }}
                src="/media/bg/Forgot password-rafiki.png"
              />
            </div>
            <div className="mx-5" style={{ marginTop: "4rem" }}>
              <div
                className="pb-5 px-5 shadow-sm rounded-4"
                style={{ backgroundColor: "#eff2f3" }}
              >
                <div
                  className="mx-auto"
                  style={{
                    backgroundColor: "#eff2f3",
                    borderRadius: "50%",
                    height: "60px",
                    width: "60px",
                    position: "relative",
                    top: "-20px",
                    bottom: "0px",
                  }}
                >
                  {" "}
                  <KeyFill className="mx-2 my-1" color="#3699ff" size={45} />
                </div>
                <h5 className="text-center mb-2" style={{ color: "#91919b" }}>
                  فراموشی رمز عبور
                </h5>
                <Controller
                  name="phoneNumber"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <PatternFormat
                      customInput={TextField}
                      variant="standard"
                      className="w-100 my-2"
                      label="شماره موبایل"
                      size="small"
                      //   value={value || ''}
                      value={field.value || ""}
                      dir="ltr"
                      format="#### ### ####"
                      autoFocus
                      //   onChange={onChange}
                      onValueChange={(value) => {
                        field.onChange(value.value);
                      }}
                    />
                  )}
                />
                {errors2.phoneNumber && (
                  <small className="text-danger">
                    لطفا شماره موبایل را وارد نمایید
                  </small>
                )}
                <div className=" text-center my-5">
                  {isLoading ? (
                    <Button
                      className="w-100"
                      variant="primary"
                      type="submit"
                      disabled
                      style={{ fontSize: "14px" }}
                    >
                      <Spinner size="sm" className="ml-3" />
                      تایید
                    </Button>
                  ) : (
                    <Button
                      className="w-100"
                      variant="primary"
                      type="submit"
                      disabled={timeForSendCod > 0 ? "disabled" : ""}
                      style={{ fontSize: "14px" }}
                    >
                      {timeForSendCod > 0 ? (
                        <>
                          <span>ارسال مجدد</span>
                          <span
                            className="d-inline-block"
                            style={{ width: "20px" }}
                          >
                            {timeForSendCod}{" "}
                          </span>
                        </>
                      ) : (
                        "تایید "
                      )}
                    </Button>
                  )}
                  {showMessage && (
                    <div className="bg-light-success border-success rounded-3 p-3 mt-3 text-success">
                      پیامی حامل رمز عبور جدید به شماره موبایل شما ارسال شد.
                    </div>
                  )}
                </div>
                <div className=" mx-5 px-5 my-4 text-center">
                  <Link
                    to="/register"
                    className="text-gray"
                    style={{ fontSize: "12px" }}
                  >
                    اگر تاکنون{" "}
                    <strong
                      className="text-primary mx-1"
                      style={{ fontSize: "14px" }}
                    >
                      ثبت نام{" "}
                    </strong>{" "}
                    نکرده اید کلیک کنید
                  </Link>
                </div>

                <div className="text-center mb-5">
                  <Link
                    to="/login"
                    style={{ fontSize: "12px" }}
                    className="text-gray"
                  >
                    برای{" "}
                    <strong
                      className="text-primary mx-1"
                      style={{ fontSize: "14px", color: "#91919b" }}
                    >
                      ورود به حساب خود
                    </strong>{" "}
                    کلیک کنید
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ) : (
          //  </div>

          <div className="d-flex">
            <Col
              lg="4"
              className="p-5  my-auto"
              style={{ marginTop: "6rem", marginRight: "5rem" }}
            >
              <div
                className="m-5 pb-5 shadow-sm rounded-4"
                style={{ backgroundColor: "#fafbff" }}
              >
                <div
                  className="mx-auto"
                  style={{
                    backgroundColor: "#fafbff",
                    borderRadius: "50%",
                    height: "80px",
                    width: "80px",
                    position: "relative",
                    top: "-30px",
                    bottom: "0px",
                  }}
                >
                  {" "}
                  <KeyFill className="mx-3 my-2" color="#3699ff" size={60} />
                </div>
                {/* <img/>  this is user icon of form */}

                <h5 className="text-center mb-2" style={{ color: "#91919b" }}>
                  فراموشی رمز عبور
                </h5>
                <p className="text-muted text-center mt-3">
                  جهت دریافت رمز عبور جدید موبایل خود را وارد نمایید
                </p>
                <div className=" px-5 py-5">
                  <Controller
                    name="phoneNumber"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <PatternFormat
                        customInput={TextField}
                        variant="standard"
                        className="w-100 my-2"
                        label="شماره موبایل"
                        size="small"
                        //   value={value || ''}
                        value={field.value || ""}
                        dir="ltr"
                        format="#### ### ####"
                        autoFocus
                        //   onChange={onChange}
                        onValueChange={(value) => {
                          field.onChange(value.value);
                        }}
                      />
                    )}
                  />
                  {errors2.phoneNumber && (
                    <small className="text-danger">
                      لطفا شماره موبایل را وارد نمایید
                    </small>
                  )}
                </div>
                <div className="px-5 text-center mt-0 mb-5">
                  {isLoading ? (
                    <Button
                      className="w-100"
                      variant="primary"
                      type="submit"
                      disabled
                    >
                      <Spinner size="sm" className="ml-3" />
                      تایید
                    </Button>
                  ) : (
                    <Button
                      className="w-100"
                      variant="primary"
                      type="submit"
                      disabled={timeForSendCod > 0 ? "disabled" : ""}
                    >
                      {timeForSendCod > 0 ? (
                        <>
                          <span>ارسال مجدد</span>
                          <span
                            className="d-inline-block"
                            style={{ width: "20px" }}
                          >
                            {timeForSendCod}{" "}
                          </span>
                        </>
                      ) : (
                        "تایید "
                      )}
                    </Button>
                  )}
                  {showMessage && (
                    <div className="bg-light-success border-success rounded-3 p-3 mt-3 text-success">
                      پیامی حامل رمز عبور جدید به شماره موبایل شما ارسال شد.
                    </div>
                  )}
                </div>
                <div className="  px-5  text-center">
                  <Link
                    to="/register"
                    className="text-muted"
                    style={{ fontSize: "12px" }}
                  >
                    اگر تاکنون ثبت نام نکرده اید{" "}
                    <strong
                      className="text-primary mx-1"
                      style={{ fontSize: "12px" }}
                    >
                      کلیک کنید
                    </strong>
                  </Link>
                </div>

                <div className="text-center">
                  <Link
                    to="/login"
                    style={{ fontSize: "12px" }}
                    className="text-muted"
                  >
                    برای ورود به حساب خود
                    <strong
                      className="text-primary mx-1"
                      style={{ fontSize: "12px", color: "#91919b" }}
                    >
                      کلیک کنید
                    </strong>
                  </Link>
                </div>
              </div>
            </Col>
            <Col>
              <img
                style={{ width: "100% ", height: "90%" }}
                src="/media/bg/Forgot password-rafiki.png"
              />
            </Col>
          </div>
        )}
      </form>
    </div>

    // <div>
    //     <div className={`card card-custom`}>
    //         {/* Start Box Header */}
    //         <div className="card-header border-0 pt-5 mx-auto mb-5" >
    //             <form id="form2" onSubmit={handleSubmit2(onSubmit2)}>
    //                 <Card style={{ width: '25rem' }} className="mx-auto center">
    //                     <Card.Body>
    //                         <Card.Title>جهت دریافت رمز عبور جدید موبایل خود را وارد نمایید</Card.Title>
    //                         <Controller
    //                             name="phoneNumber"
    //                             control={control2}
    //                             rules={{ required: true, }}
    //                             render={({ field: { onChange, value } }) => (
    //                                 <NumericFormat
    //                                     customInput={TextField}
    //                                     label="شماره موبایل"
    //                                     size='small'
    //                                     margin="normal"
    //                                     value={value || ""}
    //                                     variant="outlined"
    //                                     dir="ltr"
    //                                     // thousandSeparator=","
    //                                     // decimalScale="0"
    //                                     //prefix=" تومان "
    //                                     //maxLength={value[0] === '0' ? 13 : 12}
    //                                     format="#### ### ####"
    //                                     onChange={onChange}
    //                                 />
    //                             )}
    //                         />
    //                         {errors2.phoneNumber && <span>لطفا "شماره موبایل را وارد نمایید</span>}
    //                         <Card.Text className='pt-3'>
    //                             <Button variant="success" type="submit">
    //                                 <SaveIcon />  ورود
    //                             </Button>
    //                         </Card.Text>
    //                         <Card.Text className='pt-3'>
    //                             <Card.Link href='/#/register'>
    //                                 جهت ثبت نام کلیک نمایید
    //                             </Card.Link>
    //                         </Card.Text>
    //                         <Card.Text className='pt-3'>
    //                             <Card.Link href='/#/login'>
    //                                 جهت ورود کلیک نمایید
    //                             </Card.Link>
    //                         </Card.Text>
    //                     </Card.Body>
    //                 </Card>
    //             </form>
    //         </div>
    //     </div>
    // </div>
  );
};

export default ForgotPassword;
